import { ApiBaseWithExtendedErrorHandling } from "../../../../components-shared/api/base/api-base-with-extended-error-handling.js";
import { IExtendedApiError } from "../../../../components-shared/api/base/i-extended-api-error.js";
import { IExtendedApiResponse } from "../../../../components-shared/api/base/i-extended-api-response.js";
import { logExtendedApiError } from "../../../../components-shared/utils/notify-error-reporter.js";
import { IVariantShortInfoResponse } from "./interfaces/i-variant-short-info-response.js";

export class ProductApi extends ApiBaseWithExtendedErrorHandling {
    constructor() {
        super('/api')
    }

    protected reportError(error: IExtendedApiError): void {
        logExtendedApiError(error);
    }

    public async getVariantsShortInfo(productId: number, priceInclVat: boolean = null): Promise<IVariantShortInfoResponse> {
        let pathAndQuery = `/archive/product/${productId}/variants/shortinfo`;

        let searchParams = new URLSearchParams();
        if(priceInclVat !== null && typeof priceInclVat !== undefined){
            searchParams.append('priceInclVat', priceInclVat.toString());
        }
        
        const query = searchParams.toString();
        if(query){
            pathAndQuery += '?' + query;
        }

        const response = this.get(pathAndQuery);
        const apiResponse = await response as IExtendedApiResponse<IVariantShortInfoResponse>;

        return apiResponse ? apiResponse.result : null;
   }
}